import { createI18n } from "vue-i18n";
import { multiLang } from "@/utils/tools";

const appElement = document.getElementById("wika-configurator");
const langValue = appElement?.getAttribute("lang") || "en-GB";

const messages = multiLang;

const i18nOptions = {
  locale: langValue,
  legacy: false,
  globalInjection: true,
  fallbackLocale: "en-GB",
  messages,
};

const i18n = createI18n(i18nOptions);

export default i18n;
